var _path, _ellipse, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloudComputing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 86,
    viewBox: "0 0 130 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0976 0.838184C76.0611 -3.66464 97.5301 10.4243 102.05 32.3069C117.783 33.253 130.043 46.2631 130 61.9664C129.955 78.3321 116.602 91.5627 100.177 91.5179H99.8165C98.0115 73.9471 83.1125 60.2396 65 60.2396C46.8875 60.2396 31.9885 73.9471 30.1835 91.5179H27.2286H24.3865C11.9159 91.5301 1.45004 82.1571 0.137333 69.8015C-1.27891 56.4712 8.41933 44.5212 21.7989 43.1101C21.7177 42.1231 21.6799 41.1899 21.6799 40.2785C21.7661 21.1487 35.2906 4.69403 54.0976 0.838184Z",
    fill: "#6B92FF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 65,
    cy: 95.1106,
    rx: 30,
    ry: 29.8894,
    fill: "#3DD598"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.8622 77.0586C64.0429 75.8883 65.9572 75.8883 67.1379 77.0587L67.1539 77.0747L77.1145 86.9477C78.2952 88.118 78.2952 90.0155 77.1145 91.1858C75.9338 92.3561 74.0195 92.3561 72.8388 91.1858L68.0234 86.4127V111.017C68.0234 112.687 66.6698 114.041 65 114.041C63.3303 114.041 61.9766 112.687 61.9766 111.017V86.4126L57.1612 91.1857C55.9805 92.356 54.0662 92.356 52.8855 91.1857C51.7048 90.0154 51.7048 88.1179 52.8855 86.9476L62.8622 77.0586Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudComputing);
export default __webpack_public_path__ + "static/media/cloud-computing.b889b9fc.svg";
export { ForwardRef as ReactComponent };